import React, { useEffect, useState } from "react";
import Orange_Btn from "../../common_btn/orange_btn/Orange_Btn";
import { Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "./Login_Modal.css";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Reset_Password_Modal from "../reset_password_modal/Reset_Password_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  UserLogin,
  userSignUp,
  sendLoginOtp,
  verifyLoginOtp,
} from "../../../../features/auth/authSlice";
import SignUp_Modal from "./Signup_Modal";
import { myAccount } from "../../../../features/my_account/Slice";
import { getAllCart } from "../../../../features/cart/cartSlice";
import { getAllWishlist } from "../../../../features/wishlist/wishlistSlice";
import Green_btn from "../../common_btn/green_btn/Green_btn";
import { appSetup } from "../../../../features/master/masterSlice";
import OtpInput from "react-otp-input";

const Login_Modal = ({ email, contact, setContact, setEmail, ...props }) => {
  const [showSignUp, setShowSignUp] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    watch,
    trigger,
  } = useForm();

  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpSending, setOtpSending] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);

  const mobileNumber = watch("contact_no");

  const resetLoginOtpState = () => {
    setOtpSent(false);
    setOtp("");
    setOtpSending(false);
    setOtpVerifying(false);
    setOtpError("");
    setOtpVerified(false);

    reset();
    clearErrors();
  };

  const dispatch = useDispatch();
  const isSignin = useSelector((state) => state.auth.is_signin);
  // const onSubmit = async (data) => {
  //   if (isLoggingIn) return;

  //   setIsLoggingIn(true);

  //   try {
  //     const res = await dispatch(UserLogin(data));

  //     if (res.meta?.requestStatus === "fulfilled") {
  //       dispatch(getAllCart(isSignin));
  //       reset();
  //       dispatch(getAllWishlist());
  //       dispatch(myAccount());
  //       props?.onHide();
  //       props.setShowLogin();
  //       // setTimeout(() => {
  //       //   // navigate("/home");
  //       // }, 3000);
  //     } else if (res.meta?.requestStatus === "rejected") {
  //       if (res.payload?.errors?.email_or_contact) {
  //         setError("email_or_contact", {
  //           type: "manual",
  //           message: res.payload?.errors?.email_or_contact,
  //         });
  //       }
  //       if (res.payload?.errors?.password) {
  //         setError("password", {
  //           type: "manual",
  //           message: res.payload?.errors?.password,
  //         });
  //       }
  //     }
  //   } finally {
  //     setIsLoggingIn(false);
  //   }
  // };

  const onSubmit = async () => {
    if (!otpVerified) {
      setOtpError("Please verify your mobile number first.");
      return;
    }

    dispatch(getAllCart(isSignin));
    reset();
    dispatch(getAllWishlist());
    dispatch(myAccount());
    props?.onHide();
    props.setShowLogin();
  };

  const handleSendOtp = async () => {
    setOtpError("");

    const isValid = await trigger("contact_no");

    if (!isValid) {
      return;
    }

    setOtpSending(true);

    try {
      const res = await dispatch(
        sendLoginOtp({
          contact_no: mobileNumber,
        }),
      );

      if (res.meta?.requestStatus === "fulfilled") {
        setOtpSent(true);
        setOtp("");
        setOtpVerified(false);
        setOtpError("");
      } else {
        const errorData = res.payload;

        setOtpSent(false);

        if (errorData?.errors) {
          setError("contact_no", {
            type: "manual",
            message: errorData.errors,
          });
        } else if (errorData?.contact_no) {
          setError("contact_no", {
            type: "manual",
            message: errorData.contact_no,
          });
        } else if (errorData?.message) {
          setError("contact_no", {
            type: "manual",
            message: errorData.message,
          });
        } else if (typeof errorData === "string") {
          setError("contact_no", {
            type: "manual",
            message: errorData,
          });
        } else {
          setError("contact_no", {
            type: "manual",
            message: "Failed to send OTP",
          });
        }
      }
    } finally {
      setOtpSending(false);
    }
  };

  const handleVerifyOtp = async () => {
    setOtpError("");

    if (otp.length !== 4) {
      setOtpError("Please enter the 4 digit OTP.");
      return;
    }

    setOtpVerifying(true);

    try {
      const res = await dispatch(
        verifyLoginOtp({
          contact_no: mobileNumber,
          otp: otp,
        }),
      );

      if (res.meta?.requestStatus === "fulfilled") {
        setOtpVerified(true);
        setOtpError("");

        dispatch(getAllCart(true));
        dispatch(getAllWishlist());
        dispatch(myAccount());

        resetLoginOtpState();
        props?.onHide();
        props.setShowLogin();
      } else {
        setOtpVerified(false);

        const errorData = res.payload;

        if (errorData?.errors) {
          setOtpError(errorData.errors);
        } else if (typeof errorData === "string") {
          setOtpError(errorData);
        } else if (errorData?.message) {
          setOtpError(errorData.message);
        } else {
          setOtpError("Invalid OTP");
        }
      }
    } finally {
      setOtpVerifying(false);
    }
  };

  const user = useSelector((state) => state.myaccount.addMyaccount);

  // useEffect(() => {
  //   dispatch(myAccount());
  // }, [dispatch]);

  const app_setup = useSelector((state) => state.master.app_setup);
  // useEffect(() => {
  //   dispatch(appSetup());
  // }, [dispatch]);

  const handleLoginModalClose = () => {
    resetLoginOtpState();
    setShowSignUp(false);
    props?.onHide();
  };

  useEffect(() => {
    if (props?.show) {
      resetLoginOtpState();
      setShowSignUp(false);
    }
  }, [props?.show]);

  return (
    <Modal
      className="Login_Modal"
      size="md"
      {...props}
      onHide={handleLoginModalClose}
      centered
    >
      <div className="absolute_div">
        <p className="modal_title">{showSignUp ? "SIGN UP" : "LOGIN"}</p>

        <div className="logo_holder">
          <img
            // src="/assets/images/logo/new_ekansi_logo.png"
            src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
            className="logo_img"
          />
        </div>
      </div>

      <Modal.Body>
        <div className="close_img_div">
          <img
            src="/assets/images/modal/close.png"
            className="close_img"
            onClick={handleLoginModalClose}
          />
        </div>

        {!showSignUp && (
          <div className="login_div ">
            <div className="login_form_div">
              <Form>
                <Form.Group className="gray_input_group input_group new-wrappp">
                  <Form.Label>Mobile Number</Form.Label>

                  <div className="d-flex gap-2">
                    <Form.Control
                      type="text"
                      placeholder="Enter mobile number"
                      maxLength={10}
                      disabled={otpSent}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      {...register("contact_no", {
                        required: "Mobile Number is required",
                        pattern: {
                          value: /^[6-9][0-9]{9}$/,
                          message:
                            "Please enter a valid 10 digit mobile number",
                        },
                        onChange: (e) => {
                          let value = e.target.value.replace(/\D/g, "");
                          value = value.slice(0, 10);

                          clearErrors("contact_no");

                          setValue("contact_no", value, {
                            shouldValidate: true,
                            shouldDirty: true,
                          });
                        },
                      })}
                    />

                    {otpVerified ? (
                      <span className="text-success fw-semibold">Verified</span>
                    ) : (
                      <Green_btn
                        disabled={
                          otpSending ||
                          !/^[6-9][0-9]{9}$/.test(watch("contact_no") || "")
                        }
                        onClick={handleSendOtp}
                        btnText={
                          otpSending
                            ? "Sending..."
                            : otpSent
                            ? "OTP Sent"
                            : "Send OTP"
                        }
                      />
                    )}
                  </div>

                  {errors?.contact_no && (
                    <span className="text-danger">
                      {errors?.contact_no?.message}
                    </span>
                  )}

                  {otpSent && !otpVerified && (
                    <div className="mt-3">
                      <Form.Label>Enter OTP</Form.Label>

                      <div className="d-flex align-content-center flex-wrap gap-3">
                        <OtpInput
                          value={otp}
                          onChange={(value) => {
                            const numericValue = value
                              .replace(/\D/g, "")
                              .slice(0, 4);

                            setOtp(numericValue);
                            setOtpError("");
                          }}
                          numInputs={4}
                          renderSeparator={<span className="mx-1">-</span>}
                          renderInput={(props) => (
                            <input
                              {...props}
                              className="login_otp_input"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(e.key) &&
                                  ![
                                    "Backspace",
                                    "Delete",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "Tab",
                                  ].includes(e.key)
                                ) {
                                  e.preventDefault();
                                }
                              }}
                            />
                          )}
                          inputStyle={{
                            width: "45px",
                            height: "45px",
                            margin: "0 5px",
                            textAlign: "center",
                          }}
                        />

                        {otpError && (
                          <div className="text-danger mt-2 w-100">
                            {otpError}
                          </div>
                        )}

                        <div className="w-100">
                          <Green_btn
                            disabled={otpVerifying || otp.length !== 4}
                            onClick={handleVerifyOtp}
                            btnText={
                              otpVerifying ? "Verifying..." : "Verify OTP"
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </Form.Group>
              </Form>
            </div>

            {/* <div className="btn_holder">
              <Green_btn
                btnText={isLoggingIn ? "Logging In..." : "Login"}
                onClick={isLoggingIn ? undefined : handleSubmit(onSubmit)}
                disabled={isLoggingIn}
              />
            </div> */}

            <p className="dark_text">
              Don't have an account?{" "}
              <span
                className="link_text"
                onClick={() => {
                  setShowSignUp(true);
                }}
              >
                Create Account
              </span>
              .
            </p>

            {/* <div className="or_text_div">
              <p className="or_txt">Or</p>
            </div>

            <div className="google_img_holder">
              <div className="img_holder">
                <img src="/assets/images/modal/google.png" className="g_img" />
              </div>
              <p className="signu_with_g_txt">Sign Up with Google</p>
            </div> */}
          </div>
        )}

        {showSignUp && (
          <SignUp_Modal
            setShowSignUp={setShowSignUp}
            showSignUp={showSignUp}
            setShowAccountCreted={props?.setShowAccountCreted}
            onHide={props?.onHide}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Login_Modal;
